// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import Globals from '@/assets/scripts/global-functions.js'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
  $_veeValidate: {
      validator: 'new'
  },
  name: 'SmallBusinessDisclaimer',
  components: {
    IconArrowBack,
    IconBase,
    IconForward,
    BackButton,
    NextButton
  },
  data() {
    return {
      abn_number: "",
      isregistered: false,
      isselectedanswer: false,
      dictionary: {
        custom: {
          abn_number: {
            required: () => 'ABN number is required to proceed',
            max: 'Cannot exceed more than 11 characters',
            numeric: 'This field only accepts numeric characters'
          }
        }
      }
    }
  },
  methods: {
    SetValueForRegisteredForGST(_element){
      this.isselectedanswer = true;
      if(_element === 'btn_not_gst_registered') {
          document.getElementById("btn_not_gst_registered").classList.add("selected");
          this.SetButtonColor("btn_not_gst_registered");
          this.$parent.RemoveClassFrom('btn_gst_registered','selected');
          this.isregistered = false;
          this.$parent.EducatorInsuranceProcess.registered_for_gst = this.isregistered; 
          this.$parent.EducatorInsuranceProcess.abn_number = null;
      } else {
          this.isregistered = true;
          setTimeout(function(){ 
            document.querySelector('#abn_number').scrollIntoView();
          document.getElementById("abn_number").focus(); 
            }, 
          500);
          document.getElementById("btn_gst_registered").classList.add("selected");
          this.SetButtonColor("btn_gst_registered");
          this.$parent.RemoveClassFrom('btn_not_gst_registered','selected');
          this.$parent.EducatorInsuranceProcess.registered_for_gst = this.isregistered; 

      }
    },
    SetButtonColor(current_element){
      if(current_element == 'btn_not_gst_registered'){
          var not_current_element = 'btn_gst_registered';
      }else{
          var not_current_element = 'btn_not_gst_registered';
      }
      
      document.getElementById(current_element).classList.remove("wh-btn");
      document.getElementById(current_element).classList.add("b-btn");
      document.getElementById(not_current_element).classList.remove("b-btn");
      document.getElementById(not_current_element).classList.add("wh-btn");
    }, 
    Next(_smallbusinessdisclaimer) {
      if(this.isselectedanswer == true) {
        if(this.isregistered === true) {
          this.$validator.validateAll().then((result) => {
              if(result) {
                  this.$parent.UpdateCurrentStep(7); 
                  this.$parent.EducatorInsuranceProcess.abn_number = this.abn_number; 
                  this.$parent.EducatorNextStep(7,"EducatorStartDateOfPolicy");
              }
          });    
        } else {
          this.$parent.EducatorNextStep(7,"EducatorStartDateOfPolicy");
        }
      }
    },
    ValidateSessionData() {
      if(this.$parent.EducatorInsuranceProcess.registered_for_gst != null) {
        this.isselectedanswer = true;
        if(this.$parent.EducatorInsuranceProcess.registered_for_gst) { 
          document.getElementById("btn_gst_registered").classList.add("selected");
          this.isregistered = true; 
          this.abn_number = this.$parent.EducatorInsuranceProcess.abn_number;
          this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
        } else {
          document.getElementById("btn_not_gst_registered").classList.add("selected");
          this.isregistered = false;
        }
      }
    }
  },
  computed: {
    AllFieldsValid: function() {
        let _isvalid = false;
        if(this.isselectedanswer) {
          if(this.isregistered) {
            if(this.fields.abn_number) {
              if(this.fields.abn_number.valid) {
                _isvalid = true;
              } else{
                _isvalid = false;
              }
            }
          } else {
            _isvalid = true;
          }
        } else {
          _isvalid = false;
        }
          return _isvalid;
    }
  },
  mounted() {
    this.$parent.CurrentProcess = "EducatorInsuranceProcess";
    this.$validator.localize('en', this.dictionary);
    this.$parent.CheckWindowPathName();
    this.ValidateSessionData();
    /*
    this.$parent.RemoveClassFrom('button-item','b-btn');
    this.$parent.AddClassFrom('button-item','wh-btn');
    if(this.$parent.EducatorInsuranceProcess.registered_for_gst == true){
        document.getElementById('btn_gst_registered').classList.add("b-btn");
        document.getElementById('btn_gst_registered').classList.remove("wh-btn");
        this.isregistered = true;   
        this.abn_number = this.$parent.EducatorInsuranceProcess.abn_number;
    }else if(this.$parent.EducatorInsuranceProcess.registered_for_gst == false){
        document.getElementById('btn_not_gst_registered').classList.add("b-btn");
        document.getElementById('btn_not_gst_registered').classList.remove("wh-btn");
        his.isregistered = false; 
    }else{
        this.isregistered = false;   
        document.getElementById('btn_not_gst_registered').classList.add("selected");
    }
    */
  }
}